export default __webpack_public_path__ + "static/media/intro-img-seal.44a986aa.png";